import type { ReactElement } from 'react';

import { useL10n } from '@/l10n/useL10n';
import { useChatController } from '@/presentation/providers/chatController/chatControllerContext';
import { FadeInputField } from '@/presentation/widgets/FadeInputField';
import { PrimaryIconButton } from '@/presentation/widgets/PrimaryIconButton';
import { SafeArea } from '@/presentation/widgets/SafeArea';
import { useTextController } from '@/presentation/widgets/PrimaryInputField';

import { CANCEL_BACKGROUND_COLOR } from './chatActionType';
import styles from './ChatKeyboardMode.module.css';

/** Перенос `chat_page/chat_keyboard_mode.dart` — ввод вопроса с клавиатуры. */

export interface ChatKeyboardModeProps {
  readonly onComplete: (value: string) => void;
  readonly onCancel?: (() => void) | null;
}

export function ChatKeyboardMode(props: ChatKeyboardModeProps): ReactElement {
  const { onComplete, onCancel } = props;
  const chatController = useChatController();
  const l10n = useL10n();
  // `final TextEditingController _controller = TextEditingController()`
  const textController = useTextController<HTMLTextAreaElement>();

  const handleChange = (value: string): void => {
    textController.setValue(value);
    chatController.chatDurationController.restartTimer();
  };

  return (
    <div className={styles.root}>
      <SafeArea className={styles.inputArea}>
        <FadeInputField
          className={styles.input}
          value={textController.value}
          inputRef={textController.ref}
          hintText={l10n.enter_request}
          onChange={handleChange}
          onEditingComplete={onComplete}
          onFieldSubmitted={onComplete}
          onFocusChanged={(hasFocus, value) => {
            if (!hasFocus) onComplete(value);
          }}
        />
      </SafeArea>
      <div className={styles.actions}>
        <PrimaryIconButton
          backgroundColor={CANCEL_BACKGROUND_COLOR}
          onPressed={() => onCancel?.()}
          icon="cancel"
        />
        <PrimaryIconButton
          onPressed={() => onComplete(textController.value)}
          icon="sendMessage"
        />
      </div>
    </div>
  );
}
